module.exports = __webpack_public_path__ + "img/ic_twitter_original.cc8106cd.svg";